export enum InquiryWeddingStatus {
	Undecided = "Undecided",
	Rejected = "Rejected",
	Approved = "Approved",
}
